import { useMutation } from '@tanstack/react-query';
import { Article } from '@shared/types/articles';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useRemoveArticleLikeMutation = () => {
  return useMutation({
    mutationFn: async (params: EntityByIdParam) => await API.articles.removeLike(params),
    onSuccess: (_response, { id }) => {
      queryClient.setQueriesData({ queryKey: ['article', id] }, (oldData: Article) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          liked: false,
          likes: oldData.likes - 1,
        };
      });
      queryClient.invalidateQueries({ queryKey: ['article', id] });
    },
  });
};
